import ForgotPasswordLayout from '../layouts/ForgotPasswordLayout.vue';

const ResetPasswordNew = () => import('../views/ForgotPassword/ResetPasswordNew.vue');
const ForgotPasswordNew = () => import('../views/ForgotPassword/ForgotPasswordNew.vue');

export default {
  path: '/zapomnialem-hasla',
  component: ForgotPasswordLayout,
  children: [
    {
      path: '/',
      name: 'Auth.ForgotPassword',
      component: ForgotPasswordNew,
      meta: {
        unauthorized: true,
        background: 'white',
      },
    },
    {
      path: 'reset/:token',
      name: 'Auth.ResetPassword',
      component: ResetPasswordNew,
      meta: {
        unauthorized: true,
        background: 'white',
      },
    },
  ],
};
